import styled from 'styled-components';
import { ListItemType } from '../Base';

export interface ListItemProps<T = ListItemType> extends React.HTMLAttributes<HTMLLIElement> {
  option: T;
  key?: string;
}

export const ListItemContainer = styled.li`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const ListItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 20px;
  height: 30px;
`;

export const ListItemContent = styled.div<{ padding?: string }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;
  gap: 1px;
  overflow: hidden;

  padding: ${({ padding }) => padding || '0'};

  h1 {
    font-family: 'Inter' !important;
    padding: 0;
    font-weight: 400;
    color: ${({ theme }) => theme.text.standard};
    font-size: 14px !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-right: 0.5rem;
  }

  p {
    font-size: 12px;
    margin: 0;
    color: ${({ theme }) => theme.text.subtext};
    word-break: break-word;
  }

  svg {
    color: ${({ theme }) => theme.text.subtext};
  }

  #small {
    font-size: 11px;
  }

  #smallNoWrap {
    font-size: 11px;
    white-space: nowrap;
  }
`;

export const CubeIcon = styled.span<{ color: string }>`
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  border-radius: 3px;
  margin-top: 5px;

  background-color: ${({ color }) => color};
`;
